
import React from "react";
import { X } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

export default function BaseModal({
  open,
  onClose,
  onCloseX,
  title,
  children,
  onCancel,
  onConfirm,
  size = "md",
  hideCloseButton = false,
  textBtn = "Add",
  variant = "default",
  separator=true,
  classNameBtn,
  classNameBody,
  classNameContent,
  footer=true,
  loading,
  textCancel="Cancel",
  dir,
}) {
  const sizeClasses = {
    sm: "sm:max-w-sm",
    md: "sm:max-w-lg",
    lg: "sm:max-w-2xl",
    xl: "sm:max-w-9xl",
  };

  return (
    <Dialog open={open} onOpenChange={(state) => !state && onClose?.()} >
      <DialogContent
        dir={dir}
        className={twMerge(
          `p-0 rounded-2xl shadow-xl w-full bg-white ${classNameContent}`,
          sizeClasses[size]
        )}
      >
        {/*======== Header ========*/}
        {(title) && (
          <DialogHeader className="flex flex-row items-center justify-between  px-6 pt-7">
            {title && (
              <DialogTitle className="text-lg font-semibold text-gray-900 text-start">
                {title}
              </DialogTitle>
            )}
            
            {!hideCloseButton && (
              <button
                onClick={onClose||onCloseX}
                className="p-1 rounded-md hover:bg-gray-100 transition-colors"
              >
                <X className="w-5 h-5 text-gray-600" />
              </button>
              
            )}
          </DialogHeader>

        )}
        {separator&&<hr className="max-w-xxl mx-6 h-0.3  bg-[#D2DAE7]"/>}
        
        {/*======== Body ========*/}
        <div className={`px-6 pt-[2px] pb-2 mx-2 mb-3 overflow-y-auto ${classNameBody}`}>{children}</div>

        {/* ======== Footer ========*/}
        {footer&&<DialogFooter className="border-t border-gray-200 px-6 py-4  flex justify-end gap-3 ">
          
          <Button
            variant="outline"
            className="px-9 h-[2.625rem] border-none !text-blue-300"
            onClick={() => {
              onCancel?.();
              onClose?.();
            }}
          >
            {textCancel}
          </Button>
          <Button
          type="submit"
            variant={variant}
            loading={loading}
            className={`px-9 h-[2.625rem] ${classNameBtn}`}
            onClick={() => onConfirm?.()}
          >
            {textBtn}
          </Button>
        </DialogFooter>}
        
      </DialogContent>
    </Dialog>
  );
}
